module.exports = __webpack_public_path__ + "static/media/upload-icon.9c06a81f.svg";